<template>
  <div class="wrapper" :class="{ is_absolute: isAbsolute }">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="71"
      viewBox="0 0 36 71"
      :clip-path="`url(#${clipPathID1})`"
    >
      <defs>
        <clipPath :id="clipPathID1">
          <path d="M12 37v7h-7v-7h7Z" />
          <path d="M24 0v12h-4v-12h4Z" />
          <path d="M29 19.5v7h-14v-7h14Z" />
          <path d="M15 6v10h-12v-10h12Z" />
          <path d="M857-398v945h-1680v-945h1680Z" />
        </clipPath>
        <clipPath><path d="M36 69v2h-36v-2h36Z" /></clipPath>
        <clipPath><path d="M1357-621v1360h-2678v-1360h2678Z" /></clipPath>
        <clipPath :id="clipPathID2">
          <path d="M36 0v23.9h-36v-23.9h36Zm-5.8 6.3h-24.4l.5 3v5.2l-0.5 3.1h24.4l-0.5-3.1v-5.2l.5-3Z" />
        </clipPath>
      </defs>
      <g style="animation: 3.5s linear infinite both a1_t">
        <path
          d="M0 0h7v7h-7v-7Z"
          opacity="0"
          transform="translate(9.2,12) translate(-3.5,-3.5)"
          style="animation: 3.5s linear infinite both a0_t, 3.5s linear infinite both a0_o"
        />
      </g>
      <g style="animation: 3.5s linear infinite both a3_t">
        <path
          d="M0 0h4v12h-4v-12Z"
          opacity="0"
          transform="translate(22.2,12) translate(-2,-6)"
          style="animation: 3.5s linear infinite both a2_t, 3.5s linear infinite both a2_o"
        />
      </g>
      <path
        d="M0 0h14v7h-14v-7Z"
        opacity="0"
        transform="translate(24.2,12) translate(-7,-3.5)"
        style="animation: 3.5s linear infinite both a4_t, 3.5s linear infinite both a4_o"
      />
      <path
        d="M0 0h12v10h-12v-10Z"
        opacity="0"
        transform="translate(14.2,12) translate(-6,-5)"
        style="animation: 3.5s linear infinite both a5_t, 3.5s linear infinite both a5_o"
      />
      <ellipse
        rx="3.8"
        ry="3.8"
        opacity="0"
        transform="translate(17.2,12)"
        style="animation: 3.5s linear infinite both a6_t, 3.5s linear infinite both a6_o"
      />
      <rect y="47" width="36" height="24" fill="#f5f2e7" />
      <path
        d="M0 0h36v2h-36v-2Z"
        fill="#bab7ad"
        transform="translate(18,70) translate(-18,-1)"
        style="animation: 3.5s linear infinite both a7_t"
      />
      <g :clip-path="`url(#${clipPathID2})`" transform="translate(0,47)">
        <path d="M0 0h36v23.9h-36v-23.9Z" />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    isAbsolute: {
      type: Boolean,
      value: false,
    },
  },
  computed: {
    clipPathID1() {
      return `ClipPath-1_${Math.random(1)}`
    },
    clipPathID2() {
      return `ClipPath-2_${Math.random(2)}`
    },
    clipPathID3() {
      return Math.random(3)
    },
  },
}
</script>

<style lang="scss" scoped>
$size: 30px;
$yellow_light: #e5e1d6;
$yellow: #8d9796;
$yellow_dark: #808988;
$duration: 2s;

@mixin psuedo {
  display: block;
  content: '';
}

.wrapper {
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  background: rgba(245, 242, 231, 0.7);

  &.is_absolute {
    position: absolute;
    width: 100%;
    height: 100%;
  }
}

.loader {
  display: inline-flex;
  flex-wrap: wrap;
  width: $size * 3;
  height: $size * 3;
  transform-style: preserve-3d;
  margin-top: -120px;
  transform: rotateX(45deg) rotate(45deg);
}

.box {
  position: absolute;
  top: 0;
  left: 0;
  width: $size;
  height: $size;
  background: $yellow_light;
  box-shadow: $size * 3.75 $size * 3.75 20px rgba(0, 0, 0, 0.5);
  animation: move $duration ease-in-out infinite both;
  transform-style: preserve-3d;

  @for $i from 1 through 3 {
    &:nth-child(#{$i}) {
      animation-delay: $i/2 * -$duration;
    }
  }

  &:before,
  &:after {
    @include psuedo;
    position: absolute;
    width: $size;
    height: $size;
  }
  &:before {
    top: 100%;
    left: 0;
    background: $yellow;
    transform-origin: center top;
    transform: rotateX(-90deg);
  }
  &:after {
    top: 0;
    left: 100%;
    background: $yellow_dark;
    transform-origin: center left;
    transform: rotateY(90deg);
  }
}

@keyframes move {
  0%,
  100% {
    transform: none;
  }
  12.5% {
    transform: translate($size, 0);
  }
  25% {
    transform: translate($size * 2, 0);
  }
  37.5% {
    transform: translate($size * 2, $size);
  }
  50% {
    transform: translate($size * 2, $size * 2);
  }
  62.5% {
    transform: translate($size, $size * 2);
  }
  75% {
    transform: translate(0, $size * 2);
  }
  87.5% {
    transform: translate(0, $size);
  }
}
</style>

<style>
@keyframes a1_t {
  0% {
    transform: translate(9.2px, 12px);
    animation-timing-function: cubic-bezier(0.6, 0, 0.4, 1);
  }
  57.143% {
    transform: translate(9.2px, 55.5px);
  }
  100% {
    transform: translate(9.2px, 55.5px);
  }
}
@keyframes a0_t {
  0% {
    transform: rotate(0deg) translate(-3.5px, -3.5px);
  }
  57.143% {
    transform: rotate(90deg) translate(-3.5px, -3.5px);
  }
  100% {
    transform: rotate(90deg) translate(-3.5px, -3.5px);
  }
}
@keyframes a0_o {
  0% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.6, 0, 0.4, 1);
  }
  17.143% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes a3_t {
  0% {
    transform: translate(22.2px, 12px);
  }
  57.143% {
    transform: translate(22.2px, 12px);
    animation-timing-function: cubic-bezier(0.7, 0, 0.5, 0.8);
  }
  100% {
    transform: translate(22.8px, 63.7px);
  }
}
@keyframes a2_t {
  0% {
    transform: rotate(0deg) translate(-2px, -6px);
  }
  57.143% {
    transform: rotate(0deg) translate(-2px, -6px);
  }
  100% {
    transform: rotate(90deg) translate(-2px, -6px);
  }
}
@keyframes a2_o {
  0% {
    opacity: 0;
  }
  57.143% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.6, 0, 0.4, 1);
  }
  74.286% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes a4_t {
  0% {
    transform: translate(17.2px, 8.5px);
  }
  17.143% {
    transform: translate(17.2px, 8.5px);
    animation-timing-function: cubic-bezier(0.6, 0, 0.4, 1);
  }
  74.286% {
    transform: translate(17px, 52px);
  }
  100% {
    transform: translate(17px, 52px);
  }
}
@keyframes a4_o {
  0% {
    opacity: 0;
  }
  17.143% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.6, 0, 0.4, 1);
  }
  34.286% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes a5_t {
  0% {
    transform: translate(8.2px, 7px);
  }
  45.714% {
    transform: translate(8.2px, 7px);
    animation-timing-function: cubic-bezier(0.6, 0, 0.4, 1);
  }
  100% {
    transform: translate(8px, 57.5px);
  }
}
@keyframes a5_o {
  0% {
    opacity: 0;
  }
  45.714% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.6, 0, 0.4, 1);
  }
  62.857% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes a6_t {
  0% {
    transform: translate(17.2px, 12px);
  }
  28.571% {
    transform: translate(17.2px, 12px);
    animation-timing-function: cubic-bezier(0.6, 0, 0.4, 1);
  }
  85.714% {
    transform: translate(17.2px, 55.5px);
  }
  100% {
    transform: translate(17.2px, 55.5px);
  }
}
@keyframes a6_o {
  0% {
    opacity: 0;
  }
  28.571% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.6, 0, 0.4, 1);
  }
  45.714% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes a7_t {
  0% {
    transform: translate(18px, 70px) scale(1, 1) translate(-18px, -1px);
  }
  100% {
    transform: translate(18px, 61.2px) scale(1, 8.5) translate(-18px, -1px);
  }
}
</style>
